import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../data/mock';

const CallToAction = () => {
  const handleCall = () => {
    window.location.href = `tel:${contactInfo.phone}`;
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20intervento%20a%20Roma.%20Potete%20intervenire%20oggi?', '_blank');
  };

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-orange-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Problema urgente? Risolviamo oggi stesso
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-700 mb-8 font-medium">
            Chiama ora o scrivici su WhatsApp e interveniamo subito
          </p>
          
          <div className="flex flex-col gap-4 justify-center mb-6 max-w-lg mx-auto">
            <Button
              onClick={handleWhatsApp}
              size="lg"
              className="bg-orange-500 hover:bg-orange-600 text-white text-2xl px-12 py-8 rounded-lg shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl font-bold"
            >
              <MessageCircle className="mr-3 h-8 w-8" />
              Scrivici subito su WhatsApp
            </Button>
            
            <Button
              onClick={handleCall}
              size="lg"
              className="bg-blue-700 hover:bg-blue-800 text-white text-xl px-10 py-7 rounded-lg shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <Phone className="mr-3 h-7 w-7" />
              Chiama ora
            </Button>
          </div>
          
          <p className="text-2xl font-bold text-blue-700">
            📞 Chiama ora: 328 768 6356
          </p>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
